module.exports = function getResource(label, vars = []) {
    let resources = {
        noShippingAddressRequired: 'Cette commande ne requiert aucun paiement ou adresse de livraison. Veuillez vérifier vos renseignements avant de passer votre commande.',
        noPaymentRequired: 'Cette commande ne requiert aucun paiement. Veuillez vérifier vos renseignements avant de passer votre commande.',
        pleaseReviewOrder: `Veuillez vérifier les informations de votre commande avant ${vars[0]}`,
        pleaseReviewOrderTotal: 'Veuillez vérifier les informations relatives à votre commande avant de passer votre commande. Le total de votre commande correspond au montant total qui vous sera facturé. Cela inclut tous les droits, les taxes et les coûts d’expédition.',
        byPlacingOrderText: 'En passant votre commande, vous acceptez les ',
        termsConditions: 'conditions',
        andText: ' et ',
        privacyPolicy: 'Politique de confidentialité',
        ofText: ' du ',
        borderFreeAddress: 'service de traitement international de Sephora. Borderfree est un commerçant en ligne situé au 292 Madison Avenue, 5e étage, New York, NY, 10017, États-Unis.',
        pleaseReviewOrderInfoText: 'Veuillez vérifier les informations relatives à votre commande avant de passer votre commande.',
        byPlacingOrderCaText: 'En passant votre commande, vous acceptez de vous soumettre aux ',
        termsOfPurchase: 'Conditions d’achat',
        termsOfUse: 'les conditions d’utilisation et les'
    };
    return resources[label];
};
